export default __webpack_public_path__ + "static/media/clip.d1e429e4.svg";